import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../Styles/Home.css";
import { initScrollAnimations, cleanupScrollAnimations } from "../scrollAnimations";

const Home = () => {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.classList.add('menu-open');
    } else {
      document.body.classList.remove('menu-open');
    }
  }, [isMenuOpen]);

  useEffect(() => {
    // Initialize animations when component mounts
    initScrollAnimations();
    
    // Cleanup when component unmounts
    return () => {
      cleanupScrollAnimations();
    };
  }, []);

  const scrollToSection = (sectionId) => {
    setIsMenuOpen(false); // Close the menu first
    setTimeout(() => {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }, 300); // Wait for menu transition to complete (adjust if needed)
  };
  

  return (
<div className="home-container">
  {/* Mobile Header */}
  <header className="mobile-header mobile-only">
    <img
      src={`${process.env.PUBLIC_URL}/advLogo.png`}
      alt="Company Logo"
      className="mobile-logo"
    />
    <button className="mobile-hamburger" onClick={() => setIsMenuOpen(!isMenuOpen)}>
      <span></span>
      <span></span>
      <span></span>
    </button>

    {/* Mobile Nav Dropdown */}
    {isMenuOpen && (
      <nav className="mobile-nav">
        <button onClick={() => { scrollToSection("intro-section"); setIsMenuOpen(false); }}>
          Home
        </button>
        <button onClick={() => { scrollToSection("about-section"); setIsMenuOpen(false); }}>
          About
        </button>
        <button onClick={() => { scrollToSection("projects-preview"); setIsMenuOpen(false); }}>
          Projects
        </button>
        <button onClick={() => { scrollToSection("contact-section"); setIsMenuOpen(false); }}>
          Contact
        </button>
      </nav>
    )}
  </header>

  {/* Desktop Header */}
  <header className="fixed-header desktop-only">
    <div className="logo-container">
          <img
      src={`${process.env.PUBLIC_URL}/advLogo.png`}
      alt="Company Logo"
      className="header-logo"
    />
    </div>
    <div className="hamburger-menu" onClick={() => setIsMenuOpen(!isMenuOpen)}>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <nav className={`navigation ${isMenuOpen ? "active" : ""}`}>
      <button onClick={() => scrollToSection("intro-section")}>Home</button>
      <button onClick={() => scrollToSection("about-section")}>About</button>
      <button onClick={() => scrollToSection("projects-preview")}>Projects</button>
      <button onClick={() => scrollToSection("contact-section")}>Contact</button>
    </nav>
  </header>


      {/* Main Intro Section with Enhanced Design */}
      <section id="intro-section" className="intro-section">
        <div className="hero-background">
          <div className="floating-shapes">
            <div className="shape shape-1"></div>
            <div className="shape shape-2"></div>
            <div className="shape shape-3"></div>
            <div className="shape shape-4"></div>
            <div className="shape shape-5"></div>
            <div className="shape shape-6"></div>
            <div className="shape shape-7"></div>
            <div className="shape shape-8"></div>
            <div className="shape shape-9"></div>
            <div className="shape shape-10"></div>
            <div className="shape shape-11"></div>
            <div className="shape shape-12"></div>
            <div className="shape shape-13"></div>
            <div className="shape shape-14"></div>
            <div className="shape shape-15"></div>
            <div className="shape shape-16"></div>
            <div className="shape shape-17"></div>
            <div className="shape shape-18"></div>
            <div className="shape shape-19"></div>
            <div className="shape shape-20"></div>
          </div>
        </div>
        <div className="hero-content">
          <div className="hero-logo-container">
            <img src={`${process.env.PUBLIC_URL}/LogoA.png`} alt="Advanced Tech Logo" className="hero-logo" />
          </div>
          <div className="hero-text">
            <h1 className="hero-title">Advanced Tech</h1>
            <p className="hero-subtitle">Transforming Ideas into Digital Excellence</p>
            <div className="hero-cta">
              <button className="cta-button primary" onClick={() => scrollToSection("projects-preview")}>
                View Our Work
              </button>
              <button className="cta-button secondary" onClick={() => scrollToSection("contact-section")}>
                Get In Touch
              </button>
            </div>
          </div>
        </div>
        <div className="scroll-indicator">
          <div className="scroll-arrow"></div>
        </div>
      </section>

      {/* About Section */}
      <section id="about-section" className="about-section section-animate">
        <div className="section-header">
          <h2>About Deven Zivanovic</h2>
          <p className="section-subtitle">Lead & Sole Developer at Advanced Tech</p>
        </div>
        <div className="about-content">
          <div className="about-text">
            <div className="text-card">
              <div className="card-icon">
                <div className="icon-circle">
                  <div className="icon-rocket"></div>
                </div>
              </div>
              <h3>Full-Stack Development</h3>
              <p>
                As the lead and sole developer behind Advanced Tech, I specialize in creating 
                innovative digital solutions from concept to deployment. My passion for cutting-edge 
                technology and modern development practices drives me to deliver exceptional user 
                experiences and robust functionality.
              </p>
            </div>
            <div className="text-card">
              <div className="card-icon">
                <div className="icon-circle">
                  <div className="icon-lightning"></div>
                </div>
              </div>
              <h3>Technical Excellence</h3>
              <p>
                I take pride in my comprehensive approach to development, combining creative design 
                with solid technical implementation. From front-end interfaces to back-end systems, 
                I handle every aspect of the development process to create solutions that not only 
                work flawlessly but also inspire and engage users.
              </p>
            </div>
          </div>
          <div className="about-stats">
            <div className="stat-card">
              <div className="stat-number">100%</div>
              <div className="stat-label">Client Satisfaction</div>
              <div className="stat-bar">
                <div className="stat-fill" data-width="100"></div>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-number">24/7</div>
              <div className="stat-label">Support Available</div>
              <div className="stat-bar">
                <div className="stat-fill" data-width="100"></div>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-number">5+</div>
              <div className="stat-label">Years Experience</div>
              <div className="stat-bar">
                <div className="stat-fill" data-width="85"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Experience Section */}
      <section id="experience-section" className="experience-section section-animate">
        <div className="section-header">
          <h2>My Journey</h2>
          <p className="section-subtitle">From Western University to Professional Software Development</p>
        </div>
        <div className="experience-content">
          <div className="experience-card">
            <div className="experience-icon">
              <div className="icon-circle">
                <div className="icon-graduation"></div>
              </div>
            </div>
            <div className="experience-details">
              <h3>Western University Graduate</h3>
              <h4>Software Engineering</h4>
              <p>
                I graduated from Western University with a degree in Software Engineering, where I developed 
                a strong foundation in computer science principles, software architecture, and modern development 
                methodologies. This rigorous program equipped me with both theoretical knowledge and practical 
                skills essential for building robust, scalable applications.
              </p>
            </div>
          </div>
          <div className="experience-card">
            <div className="experience-icon">
              <div className="icon-circle">
                <div className="icon-code"></div>
              </div>
            </div>
            <div className="experience-details">
              <h3>Professional Development</h3>
              <h4>Full-Stack Expertise</h4>
              <p>
                Since graduation, I've dedicated myself to mastering the full software development lifecycle. 
                From front-end user interfaces using React and modern JavaScript to back-end systems with 
                Node.js and databases, I bring a comprehensive approach to every project. My experience spans 
                web applications, mobile solutions, and desktop software.
              </p>
            </div>
          </div>
          <div className="experience-card">
            <div className="experience-icon">
              <div className="icon-circle">
                <div className="icon-innovation"></div>
              </div>
            </div>
            <div className="experience-details">
              <h3>Continuous Innovation</h3>
              <h4>Modern Technologies</h4>
              <p>
                I stay at the forefront of technology trends, constantly learning and implementing the latest 
                tools and frameworks. Whether it's exploring new JavaScript libraries, cloud technologies, 
                or emerging development patterns, I ensure that every solution I deliver uses the most 
                appropriate and cutting-edge technologies available.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Project Preview Section */}
      <section id="projects-preview" className="projects-preview-section section-animate">
        <div className="section-header">
          <h2>Featured Projects</h2>
          <p className="section-subtitle">Explore our diverse portfolio of successful digital solutions</p>
        </div>
        <div className="projects-grid">
          <div 
            className="project-card" 
            onClick={() => navigate("/gallery")}
            onMouseEnter={(e) => {
              const video = e.currentTarget.querySelector('video');
              if (video) video.play().catch(() => {});
            }}
            onMouseLeave={(e) => {
              const video = e.currentTarget.querySelector('video');
              if (video) {
                video.pause();
                video.currentTime = 0;
              }
            }}
          >
            <div className="project-image">
              <video 
                src="/lines/leap-demo.mov" 
                alt="Leap Queue Management" 
                muted 
                loop
                poster="/lines/leap1.png"
              />
            </div>
          </div>
          <div 
            className="project-card" 
            onClick={() => navigate("/gallery")}
            onMouseEnter={(e) => {
              const video = e.currentTarget.querySelector('video');
              if (video) video.play().catch(() => {});
            }}
            onMouseLeave={(e) => {
              const video = e.currentTarget.querySelector('video');
              if (video) {
                video.pause();
                video.currentTime = 0;
              }
            }}
          >
            <div className="project-image">
              <video 
                src="/clockway/CLockwayMobile.mov" 
                alt="Clockway Mobile" 
                muted 
                loop
              />
            </div>
          </div>
          <div 
            className="project-card" 
            onClick={() => navigate("/gallery")}
            onMouseEnter={(e) => {
              const video = e.currentTarget.querySelector('video');
              if (video) video.play().catch(() => {});
            }}
            onMouseLeave={(e) => {
              const video = e.currentTarget.querySelector('video');
              if (video) {
                video.pause();
                video.currentTime = 0;
              }
            }}
          >
            <div className="project-image">
              <video 
                src="/clockway/ClockwayDesktop.mov" 
                alt="Clockway Desktop" 
                muted 
                loop
              />
            </div>
          </div>
        </div>
        <div className="projects-cta">
          <button className="cta-button primary" onClick={() => navigate("/gallery")}>
            View All Projects
          </button>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact-section" className="contact-section section-animate">
        <div className="section-header">
          <h2>Let's Work Together</h2>
          <p className="section-subtitle">Ready to bring your vision to life? We'd love to hear from you.</p>
        </div>
        <div className="contact-content">
          <div className="contact-info">
            <div className="info-card">
              <div className="info-icon">
                <div className="icon-chat"></div>
              </div>
              <h3>Start a Conversation</h3>
              <p>Have a project in mind? Let's discuss how we can transform your ideas into digital reality.</p>
            </div>
            <div className="contact-methods">
              <div className="contact-method">
                <div className="method-icon">
                  <div className="icon-email"></div>
                </div>
                <div className="method-details">
                  <h4>Email</h4>
                  <p>dzivanovic@advancedmetalshop.ca</p>
                </div>
              </div>
              <div className="contact-method">
                <div className="method-icon">
                  <div className="icon-phone"></div>
                </div>
                <div className="method-details">
                  <h4>Phone</h4>
                  <p>(647) 825-9116</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="modern-footer">
        <div className="footer-content">
          <div className="footer-brand">
            <img src={`${process.env.PUBLIC_URL}/LogoA.png`} alt="Advanced Tech Logo" className="footer-logo" />
            <p className="footer-tagline">Transforming Ideas into Digital Excellence</p>
          </div>
          <div className="footer-links">
            <div className="footer-section">
              <h4>Navigation</h4>
              <ul>
                <li onClick={() => scrollToSection("about-section")}>About</li>
                <li onClick={() => scrollToSection("projects-preview")}>Projects</li>
                <li onClick={() => scrollToSection("contact-section")}>Contact</li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>Contact</h4>
              <ul>
                <li>dzivanovic@advancedmetalshop.ca</li>
                <li>(647) 825-9116</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2024 <span>Advanced Tech</span>. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default Home;
